import { render, staticRenderFns } from "./RectangleObjectLocator.vue?vue&type=template&id=85cc3398&scoped=true&"
import script from "./RectangleObjectLocator.vue?vue&type=script&lang=ts&"
export * from "./RectangleObjectLocator.vue?vue&type=script&lang=ts&"
import style0 from "./RectangleObjectLocator.vue?vue&type=style&index=0&id=85cc3398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc3398",
  null
  
)

export default component.exports